export const MAXIMUM_FILE_SIZE = 10;
